import * as api from 'services/api';
import qs from 'qs';
import { addError } from 'actions/error';

export const getInstitutionInfo = (id) => (dispatch) =>
  api
    .get(`education/institutions/${id}`, 'GET_INSTITUTION_INFO', dispatch)
    .catch(() => dispatch(addError(new Error('GET_INSTITUTION_INFO_ERROR'))));

export const getInstitutionFilters = (options) => (dispatch) => {
  const queryString = qs.stringify(options, { arrayFormat: 'index' });

  return api
    .get(
      `education/institutions/programs/filter-options?${queryString}`,
      'GET_INSTITUTION_FILTERS',
      dispatch
    )
    .catch(() => dispatch(addError(new Error('GET_INSTITUTION_FILTERS_ERROR'))));
};

export const getInstitutionSpecialties = () => (dispatch) =>
  api
    .get('education/specialties', 'GET_INSTITUTION_SPECIALTIES', dispatch)
    .catch(() => dispatch(addError(new Error('GET_INSTITUTION_SPECIALTIES_ERROR'))));

export const getCoursesFilters = (options) => (dispatch) => {
  const queryString = qs.stringify(options, { arrayFormat: 'index' });

  return api
    .get(`education/courses/filter-options?${queryString}`, 'GET_COURSES_FILTERS', dispatch)
    .catch(() => dispatch(addError(new Error('GET_COURSES_FILTERS_ERROR'))));
};
